module.exports = __webpack_public_path__ + "static/series_2310-fa22726775fb3226d5114095496a388a.png";